"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChannelMessageStorage_1 = __importDefault(require("./ChannelMessageStorage"));
var ChatMemoryStorageAdapter = /** @class */ (function () {
    function ChatMemoryStorageAdapter() {
        this.channelMessageStorages = {};
    }
    ChatMemoryStorageAdapter.prototype.channelMessageStorage = function (channelId) {
        if (!this.channelMessageStorages[channelId]) {
            this.channelMessageStorages[channelId] = new ChannelMessageStorage_1.default(channelId);
        }
        return this.channelMessageStorages[channelId];
    };
    return ChatMemoryStorageAdapter;
}());
exports.default = ChatMemoryStorageAdapter;
//# sourceMappingURL=ChatMemoryStorageAdapter.js.map